import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PagamentoConcluido() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState({ loading: true, paid: false, message: "Confirmando pagamento..." });
  const orderNsu = params.get("order_nsu");

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;
    const check = async () => {
      try {
        if (orderNsu) {
          const { data } = await api.get(`/payments/status/${orderNsu}`);
          if (cancelled) return;
          if (data.payment_status === "paid") {
            setState({ loading: false, paid: true, message: "Pagamento confirmado! Seu plano já está ativo." });
            refresh();
            return true;
          }
          setState({ loading: true, paid: false, message: "Aguardando confirmação do pagamento... (liberação automática via webhook)" });
        } else {
          if (cancelled) return true;
          setState({ loading: false, paid: false, message: "Pagamento recebido. Seu acesso será liberado automaticamente em instantes. Confira em Planos." });
          return true;
        }
        return false;
      } catch {
        if (cancelled) return true;
        attempts += 1;
        if (attempts >= 10) {
          setState({ loading: false, paid: false, message: "Ainda não identificamos a confirmação. Aguarde alguns minutos e recarregue. Se pagou, o acesso libera sozinho." });
          return true;
        }
        return false;
      }
    };
    check();
    const id = setInterval(async () => {
      const done = await check();
      if (done) clearInterval(id);
    }, 5000);
    return () => { cancelled = true; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderNsu]);

  return (
    <div className="max-w-lg mx-auto text-center space-y-6 py-10" data-testid="pagamento-concluido-page">
      {state.loading ? (
        <Loader2 className="w-12 h-12 text-emerald-400 animate-spin mx-auto" />
      ) : state.paid ? (
        <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto" />
      ) : (
        <XCircle className="w-14 h-14 text-amber-400 mx-auto" />
      )}
      <h1 className="font-heading text-2xl font-bold text-slate-100">Pagamento concluído</h1>
      <p className="text-sm text-slate-400">{state.message}</p>
      {orderNsu && <p className="text-xs font-mono text-slate-500">Pedido: {orderNsu}</p>}
      <div className="flex gap-3 justify-center">
        <Link to="/planos" className="px-4 py-2 rounded-lg bg-slate-800 text-slate-100 text-sm font-semibold">Voltar aos Planos</Link>
        <Link to="/dashboard" className="px-4 py-2 rounded-lg bg-emerald-500 text-emerald-950 text-sm font-semibold">Ir ao Dashboard</Link>
      </div>
    </div>
  );
}
